<div class="valid-status-cell-renderer">
  <mydocma-custom-mat-icon [iconName]="'_error2'" *ngIf="value === validationResults.Error">
  </mydocma-custom-mat-icon>
  <mydocma-custom-mat-icon [iconName]="'_warning2'" *ngIf="value === validationResults.Warning">
  </mydocma-custom-mat-icon>
  <mydocma-custom-mat-icon class="mydocma-custom-mat-icon-ok" [iconName]="'_check-filled'" *ngIf="value === validationResults.Ok" style="">
  </mydocma-custom-mat-icon>
</div>
